import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';

// Register AG Grid's community feature set once, app-wide.
ModuleRegistry.registerModules([AllCommunityModule]);

// ─── Brand colours — kept in sync with src/styles/theme.js's `brand`/`gray`
// scales, ported from MUI's own Dashboard template source.
const accentColor = 'hsl(210, 98%, 48%)'; // brand[400]

const gray = {
  50: 'hsl(220, 35%, 97%)',
  100: 'hsl(220, 30%, 94%)',
  700: 'hsl(220, 20%, 25%)',
  800: 'hsl(220, 30%, 6%)',
  900: 'hsl(220, 35%, 3%)',
};

const baseParams = {
  fontFamily: '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',
  accentColor,
  borderRadius: 8,
  wrapperBorderRadius: 8,
  headerFontWeight: 600,
  rowVerticalPaddingScale: 1,
  spacing: 8,
};

export const agGridThemeLight = themeQuartz.withParams({
  ...baseParams,
  browserColorScheme: 'light',
  backgroundColor: 'hsl(0, 0%, 99%)',
  foregroundColor: 'hsl(220, 30%, 6%)',
  headerTextColor: 'hsl(220, 30%, 6%)',
  headerBackgroundColor: gray[50],
  oddRowBackgroundColor: gray[100],
  rowHoverColor: 'hsla(210, 98%, 48%, 0.06)',
  selectedRowBackgroundColor: 'hsla(210, 98%, 48%, 0.12)',
  borderColor: 'hsla(220, 20%, 80%, 0.4)',
});

export const agGridThemeDark = themeQuartz.withParams({
  ...baseParams,
  browserColorScheme: 'dark',
  backgroundColor: gray[800],
  foregroundColor: '#ffffff',
  headerTextColor: '#ffffff',
  headerBackgroundColor: gray[900],
  oddRowBackgroundColor: 'hsl(220, 30%, 9%)',
  rowHoverColor: 'hsla(210, 98%, 48%, 0.15)',
  selectedRowBackgroundColor: 'hsla(210, 98%, 48%, 0.25)',
  borderColor: 'hsla(220, 20%, 25%, 0.6)',
});

// Minimal French locale — only the keys our grids actually surface
// (pagination controls + empty/loading states). Extend as new features are used.
export const agGridLocaleFr = {
  page: 'Page',
  more: 'Plus',
  to: 'à',
  of: 'sur',
  next: 'Suivant',
  last: 'Dernier',
  first: 'Premier',
  previous: 'Précédent',
  loadingOoo: 'Chargement...',
  noRowsToShow: 'Aucune donnée trouvée',
  pageSizeSelectorLabel: 'Lignes par page :',
  footerTotal: 'Total',
};
